import { Component, OnInit } from '@angular/core';
import { DataLogicService } from 'app/infrastructure/services/dataLogic.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrowlType, AlertService } from 'app/infrastructure/services/alert.service';
import { DataLogic } from 'app/infrastructure/model/interfaces/dataLogic.interface';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
    selector: 'sx-data-logic',
    templateUrl: './data-logic.component.html',
})
export class DataLogicComponent implements OnInit {
    preguntarSiDeseaBorrar = [];
    organizations: any;
    dataLogic: DataLogic[] = new Array<DataLogic>();

    constructor( 
        private dataLogicService: DataLogicService,
        private alertService: AlertService,
        private sxTranslationService: SxTranslationService,
        private modalService: NgbModal,
        private router: Router,
        private aRoute: ActivatedRoute
    ){}

    ngOnInit() {  
        this.getAll();
    }

    getAll() {
        this.dataLogicService.getAll().subscribe(res => {
            this.dataLogic = res;
        });
    }

    edit(dataLogicId: string) {
        this.router.navigate(['.', dataLogicId], { relativeTo: this.aRoute });
    }

    delete(dataLogicId: string, name: string) {
        const modalRef = this.modalService.open(ConfirmacionModalComponent);
        const modalInstance = <ConfirmacionModalComponent>modalRef.componentInstance;
        const text = this.sxTranslationService.getResource('DISABLE_TEXT');
        modalInstance.titulo = `${text} ${name} ?`;
    
        modalRef.result
        .then(confirmacion => {
            this.dataLogicService.delete(dataLogicId)
            .then(success => {
                if (success) {
                    this.alertService.showGrowl({
                        type: GrowlType.SUCCESS,
                        body: 'SUCCESSFUL_DELETE_OF_FLOW_WITH_CODFLOW',
                    }, 
                    { name: name });
                } else {
                    this.alertService.showGrowl({
                        type: GrowlType.DANGER,
                        body: 'SOC_FE_0010_COULD_NOT_DELETE_FLOW_WITH_CODE',
                    }, 
                    { name: name });
                }
                this.dataLogic = this.dataLogic.filter(f => f.dataLogicId !== dataLogicId);
            });
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/datalogic/data-logic.component.ts